import type {Bucket} from './draggable-list-bucketed';

export const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);

    return list;
};

export const getEmptySlotsText = (bucket: Bucket) => {
    if (bucket.items.length === 0 && bucket.emptyState) {
        return bucket.emptyState;
    }

    if (!bucket.slots) {
        return null;
    }

    const currentItemCount = bucket.items.length;

    const emptySlots = Math.max(0, (bucket.slots || 0) - currentItemCount);

    // Only return text if there are empty slots
    if (emptySlots === 0) return null;

    return `${emptySlots} empty ${emptySlots === 1 ? 'slot' : 'slots'} remaining`;
};

export const getDraggingStyle = (draggableStyle: any) => {
    // need to destructure left and top out of restStyles even though they are unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {left, ...restStyles} = draggableStyle;

    const draggingStyle = {
        margin: '0 0 8px 0',
        ...restStyles,
    } as const;

    // This locks the x-axis so the item is only draggable vertically
    if (draggableStyle.transform) {
        const axisLockY = `translate(0px${draggableStyle.transform.slice(
            draggableStyle.transform.indexOf(','),
            draggableStyle.transform.length
        )}`;

        return {
            ...draggingStyle,
            transform: axisLockY,
        };
    }

    return draggingStyle;
};
